import { authRoutes } from "modules/Auth/route";

const defaultRoutes = [...authRoutes];

export default defaultRoutes;
